import { render } from "./colorPicker.vue?vue&type=template&id=b8bbf28e&scoped=true"
import script from "./colorPicker.vue?vue&type=script&lang=js"
export * from "./colorPicker.vue?vue&type=script&lang=js"

import "./colorPicker.vue?vue&type=style&index=0&id=b8bbf28e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/weektodo/weektodo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8bbf28e"]])

export default __exports__